// Danish wall-clock time, regardless of the browser's timezone - same as the server does.
const formatter = new Intl.DateTimeFormat('da-DK', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Copenhagen',
});

// The same date format without the time - mirrors the server's "d. MMMM yyyy".
const dateOnlyFormatter = new Intl.DateTimeFormat('da-DK', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'Europe/Copenhagen',
});

/**
 * "7. september 2025, kl. 14.00" - the one date format on the site. Mirrors
 * OpenHouseSlot.Format on the server; the comma is what Intl leaves out.
 */
export function formatDanishDateTime(isoDate: string | null | undefined): string {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;

  return formatter.format(date).replace(' kl.', ', kl.');
}

/**
 * "7. september 2025" - the site date format without the time.
 */
export function formatDanishDate(isoDate: string | null | undefined): string {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;

  return dateOnlyFormatter.format(date);
}

const numericDateFormatter = new Intl.DateTimeFormat('da-DK', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'Europe/Copenhagen',
});

/**
 * "07-09-2025" - the compact date for tight spots like the search result rows.
 */
export function formatDanishNumericDate(isoDate: string | null | undefined): string {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;

  return numericDateFormatter.format(date).replaceAll('.', '-');
}

// YYYY-MM-DD on the Danish calendar, so two days compare as strings.
const dayKeyFormatter = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Copenhagen' });

/**
 * Whether a date falls on a later Danish calendar day than `now`. Today and
 * earlier are not - mirrors the advert fact box's "takeover date has passed".
 * Unparseable or missing dates count as not in the future.
 */
export function isFutureDanishDate(isoDate: string | null | undefined, now: Date = new Date()): boolean {
  if (!isoDate) return false;

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return false;

  return dayKeyFormatter.format(date) > dayKeyFormatter.format(now);
}
